var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnNotifCupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB2F06;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    className: "st0",
    d: "M33.1,13.6C23,4.3,29.2,10.1,21.3,2.8c-0.6-0.6-1.6-0.6-2.2,0c-8,7.3-1.7,1.6-11.8,10.8 C6.4,14.4,6,15.4,6,16.5v19.2c0,0.9,0.7,1.6,1.6,1.6h25.3c0.9,0,1.6-0.7,1.6-1.6V16.5C34.4,15.4,33.9,14.4,33.1,13.6z M9.9,19 c0.2-2.2,2.2-3.8,4.4-3.5c2.2,0.2,3.8,2.2,3.5,4.4c-0.2,2-1.9,3.6-4,3.6C11.5,23.2,9.8,21.3,9.9,19z M18.2,31.6 c-0.3,0.6-1,0.9-1.6,0.7c-0.6-0.3-0.9-1-0.7-1.6L22,16c0.3-0.6,1-0.9,1.6-0.7s0.9,1,0.7,1.6L18.2,31.6z M26.5,33.3 c-2.4,0.3-4.6-1.5-4.9-3.9c-0.3-2.4,1.5-4.6,3.9-4.9c2.4-0.3,4.6,1.5,4.9,3.9c0,0.2,0,0.3,0,0.5C30.6,31.2,28.8,33.2,26.5,33.3 L26.5,33.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    className: "st0",
    d: "M14.4,17.5c-1.1-0.3-2.2,0.3-2.4,1.4s0.3,2.2,1.4,2.4s2.2-0.3,2.4-1.4c0-0.2,0.1-0.3,0.1-0.5 C15.9,18.5,15.3,17.6,14.4,17.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44_1_",
    className: "st0",
    d: "M26.5,27c-1.1-0.3-2.2,0.3-2.4,1.4s0.3,2.2,1.4,2.4s2.2-0.3,2.4-1.4c0-0.2,0.1-0.3,0.1-0.5 C28.1,28,27.5,27.2,26.5,27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNotifCupon);
export default __webpack_public_path__ + "static/media/icn_notif-cupon.95dac0137164b5174f1e2d67750bfda7.svg";
export { ForwardRef as ReactComponent };